import { Component } from '@angular/core';
import { NavController, NavParams, ToastController, LoadingController, ModalController, AlertController } from 'ionic-angular';

import { Item, Api, Tracking, User, Reviews, Master  } from '@providers/asset/index';
import { FormItemPage, DetailImagePage, FormReviewPage, DetailItemPage } from '../';

declare var cordova:any;

@Component({
  selector: 'page-detail-item-erp',
  templateUrl: 'page.html'
})
export class DetailItemERPPage {

  item = {
    id: '',
    scm_asset_id: '',
    asset_name: '',
    asset_classification_id: '',
    asset_classification_name: '',
    asset_location_id: '',
    asset_location_name: '',
    asset_old_code: '',
    asset_temp_code: '',
    asset_new_code: '',
    asset_condition_id: '',
    asset_condition_name: '',
    estimated_value: '',
    acquisition_year: '',
    item_amount: 1,
    related_to:''
  };

  images:any=[];
  base_url='';
  url_img='';
  tracking=0;
  akses:any={};

  fromAppsView : any= false;

  constructor(
    public  itemApi    : Item,
    public  api        : Api,
    public  trackingApi: Tracking,
    public  navCtrl    : NavController,
    public  navParams  : NavParams,
    public  toastCtrl  : ToastController,
    public  loadingCtrl: LoadingController,
    private alertCtrl  : AlertController,
    public  modalCtrl  : ModalController,
    public  userApi    : User,
    public  reviewApi  : Reviews,
    public  masterApi  : Master
  ) {
    this.akses = this.userApi.akses;
    this.item.id = navParams.get('id');
    this.fromAppsView = navParams.get('fromAppsView');
    this.getItemByID();
    this.url_img = this.api.url+'/client/uploads/';
    this.base_url = this.api.url;
    this.tracking = trackingApi.active;
  }

  presentToast(msg){
    this.toastCtrl.create({
      message: msg,
      duration: 3000,
      position: 'top'
    }).present();
  }

  getItemByID(){
    let loading = this.loadingCtrl.create({
      content: 'Please wait...'
    });
    loading.present();

    let params = {
      id: this.item.id,
      data_source : 'erp'
    };
    this.itemApi.get_detail(params).subscribe((resp:any) => {
      if(resp.data!=''){
        if(resp.data.length>0){
          this.item = resp.data[0];
        }
      }else{
        this.navCtrl.pop();
        this.presentToast('This item not available at ERP database !')
      }

      loading.dismiss();
    }, (err) => {
      loading.dismiss();
    });
  }

  getImagesByID(){
    let loading = this.loadingCtrl.create({
      content: 'Please wait...'
    });
    loading.present();

    let params = {asset_id: this.item.id};
    this.itemApi.getImages(params).subscribe((resp:any) => {
      if(resp.data.length>0){
        this.images = resp.data;
      }
      loading.dismiss();
    }, (err) => {
      loading.dismiss();
    });
  }

  viewImage(rec:any = {}) {
    let profileModal = this.modalCtrl.create(DetailImagePage, { 
      url_image : this.url_img+rec.generated_name,
      detail: rec
    });
    profileModal.present();
  }
 

  nextItem(){
    let data:any = {
      location_id: this.item.asset_location_id,
      asset_item_id: this.item.id,
      act:'scanned'
    }
    
    this.track_item(data);
  }

  edit() {
    this.navCtrl.push(FormItemPage, {id:this.item.id});
  }

  track_item(params){
    let loading = this.loadingCtrl.create({
      content: 'Please wait...'
    });
    loading.present();

    this.trackingApi.post_item(params).subscribe((resp:any) => {      
      loading.dismiss();
    }, (err) => {
      loading.dismiss();
    });
  }

  add_review(){
    this.navCtrl.push(FormReviewPage, {
      asset_id      :this.item.id,
      asset_name    :this.item.asset_name,
      location_id   :this.item.asset_location_id,
      location_name :this.item.asset_location_name
    });
  }

  print(){
    let loading = this.loadingCtrl.create({
      content: 'Please wait...'
    });
    loading.present();
    
   let params = {t:this.item.asset_new_code, s:0};
    this.masterApi.getBaseQR(params).subscribe((resp:any) => {
      let me = this;
      let img = resp.image_data_base64;
      cordova.plugins.brotherPrinter.findBluetoothPrinters(function(printers){
          console.log(printers);
          cordova.plugins.brotherPrinter.setPrinter(printers[0], function(){
            cordova.plugins.brotherPrinter.printViaSDK(img,function(statusCode){
              console.log(statusCode);
              if(statusCode.result){
                me.presentToast(statusCode.result);
              }
              loading.dismiss();
            },function(err){
              console.log(err);
              loading.dismiss();
            });
          },function(err) {
            console.log(err);
            loading.dismiss();
          });
      },function(err){
          console.log(err);
          loading.dismiss();
      });
    }, (err) => {
      loading.dismiss();
    });
    
  }

  popView(){
    if(this.fromAppsView == true){
      this.navCtrl.pop();
    }else{
      this.navCtrl.push(DetailItemPage, {
        id : this.item.id,
        fromERPview : true
      });
    }
    
  }

}



// WEBPACK FOOTER //
// ./src/pages/asset/detail_item_erp/page.ts